var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',[_c('div',{staticClass:"mainView1"},_vm._l((_vm.canSelectEvents),function(item){return _c('div',{staticClass:"itemStyle1"},[_c('div',{staticClass:"eventStyle"},[_vm._v(" "+_vm._s(item)+" ")])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }